import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import CompanyForm from "./CompanyForm";

const EditCompany = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Company - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <CompanyForm />
      </div>
      </div>
     
    </>
  );
};

export default EditCompany;
